import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './styles.css';

interface ILoadableErrorProps {
  text?: string;
  onRetry(): void;
}

export const ERROR_TEXT =
  'Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.';

export const LoadableError = ({ text, onRetry }: ILoadableErrorProps) => {
  return (
    <div className={styles['container']}>
      <p className={styles['text']}>{text || ERROR_TEXT}</p>
      <Button onClick={onRetry}>Повторить</Button>
    </div>
  );
};
